import { SText } from "@/components/atoms";
import ArrowDownBounceIcon from "@/components/atoms/icons/ArrowDownBounceIcon";
import SHeading from "@/components/atoms/SHeading";
import { VIDEO_PHOTOBOOTH_HOT } from "@/constants";
import { cardsWhyPhotoBooth } from "@/constants/values";
import { useTranslation } from "react-i18next";

const WhyPhotoBooths: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="relative mb-16">
        <SHeading
          tAlign="center"
          text={t("home.why.title")}
          className="font-extrabold md:text-4xl text-xl min-h-[2rem] md:min-h-[3rem]"
        />
        <SText
          text={t("home.why.description")}
          className="mt-2 md:text-2xl text-center min-h-[2rem] md:min-h-[3rem]"
        />
        <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-14">
          <ArrowDownBounceIcon />
        </div>
      </div>
      <div className="relative w-full aspect-video">
        <iframe
          title="Hot Photobooth Video"
          src={VIDEO_PHOTOBOOTH_HOT}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          className="absolute top-0 left-0 w-full h-full"
          frameBorder="0"
          scrolling="no"
          allowFullScreen
        ></iframe>
      </div>

      <SHeading
        tAlign="center"
        text={t("home.why.business_suitable")}
        className="my-8 font-extrabold md:text-3xl text-xl"
      />
      <div className="flex flex-col max-w-3xl mx-auto items-center justify-center gap-4">
        {cardsWhyPhotoBooth(t).map((record, index) => (
          <div
            key={`WhyPhotoBooth-${index}`}
            className="flex gap-4 p-4 shadow-sm bg-primary-light w-full rounded-3xl"
          >
            <div className="flex items-center text-lg">
              <record.icon />
            </div>
            <p
              className="my-4 text-lg md:text-2xl"
              dangerouslySetInnerHTML={{ __html: record.description }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyPhotoBooths;
